/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
import { reducer as toastrReducer } from 'react-redux-toastr';

import credits from 'reducers/credits';
import instances from 'reducers/instances';
import modal from 'reducers/modal';
import paymentMethods from 'reducers/paymentMethods';
import projects from 'reducers/projects';
import sessions from 'reducers/sessions';
import skus from 'reducers/skus';
import ui from 'reducers/ui';
import users from 'reducers/users';
import { groupsReducer } from 'reducers/groups/groupsReducer';
import { regionsReducer } from 'reducers/regions/regionsReducer';

/**
 * Merges the main reducer with the router state
 * using `connected-react-router`
 */
const createReducer = (history) =>
  combineReducers({
    credits,
    instances,
    modal,
    paymentMethods,
    projects,
    router: connectRouter(history),
    sessions,
    skus,
    toastr: toastrReducer,
    ui,
    users,
    groups: groupsReducer,
    regions: regionsReducer
  });

export default createReducer;
